/* app/js/src/components/clipping-studio/panels/text-panel/text-template-card/clipping-studio-text-template-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  min-width: 0;
}
.text-template-card__preview-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.text-template-card__preview-inner--transparent {
  background-size: 12px 12px;
  background-position: 50%;
}
.text-template-card__preview-inner--checker-light {
  background-color: #fff;
  background-image: repeating-conic-gradient(#d1d5db 0% 25%, #fff 0% 50%);
}
.text-template-card__preview-inner--checker-dark {
  background-color: #7f8590;
  background-image: repeating-conic-gradient(#8c929b 0% 25%, #707680 0% 50%);
}
.text-template-card__badge {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1.2;
}
.text-template-card__display-text {
  font-family: "Open Sans", sans-serif;
  line-height: 1.1;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
  padding: 8px;
}
/*# sourceMappingURL=clipping-studio-text-template-card.component.css.map */
